export const buildInstrumentKeyCandidates = (instrumentKey: string) => {
    const normalized = instrumentKey.trim().toUpperCase();
    if (!normalized) return [];

    const keys: string[] = [];
    const push = (key: string) => {
        if (!key || keys.includes(key)) return;
        keys.push(key);
    };

    if (normalized.endsWith('.LSE')) {
        push(normalized);
        push(normalized.replace(/\.LSE$/i, '.L'));
        return keys;
    }

    if (normalized.endsWith('.L')) {
        push(normalized.replace(/\.L$/i, '.LSE'));
        push(normalized);
        return keys;
    }

    push(normalized);
    return keys;
};
